@for (item of navList; track item; let i = $index) {
  <li
    class="w-8 hover:bg-red-800 h-full flex justify-center"
    >
    <a
      [routerLink]="[item.path]"
      (click)="getActiveClass(item)"
      [ngClass]="navAnchorStyle"
      [routerLinkActive]="activeLink"
      class="w-8 hover:bg-red-800 pb-0.5 flex items-center justify-center"
      >
      @if (item && item.icon && item.icon.indexOf('.svg') != -1) {
        <img
          [src]="item.icon"
          class="inline h-5 w-5"
          [alt]="item.name || 'navigation icon'"
        />
      }
      @if (item && item.icon && item.icon.indexOf('.svg') == -1) {
        <img
          [src]="item.icon"
          class="inline"
          />
      }
    </a>
  </li>
}
